export const USER_ROLE_OPTIONS = [
  'Account Management',
  'Brand Management',
  'Business Development',
  'Buyer/Purchasing',
  'Category Manager',
  'Customer Service / Support',
  'Digital Merchandising',
  'Executive',
  'Finance',
  'Human Resources',
  'Information Technology',
  'Investor Relations',
  'Lawyer / Attorney',
  'Logistics',
  'Marketing',
  'Operations',
  'Owner',
  'Partnerships',
  'Product Development',
  'Research & Development',
  'Revenue Operations',
  'Sales Enablement',
  'Sales Operations',
  'Sourcing / Procurement',
  'Supply Chain',
];

export const COMPANY_TYPE_OPTIONS = [
  'Key Account Retailer',
  'Key Account Participant',
  'Key Account Banner',
  'Confidential Retailer',
  'Non Data Sharing Retailer',
  'Wholesaler',
  'Retailer',
  'Circana Partner Account',
  'Brand',
  'Manufacturer',
  'Parent Organization',
  'Agency',
  'Broker',
  'Contract Manufacturer',
  'Distributor',
  'Ingredient Supplier',
  'Ingredient Supplier & Contract Manufacturer',
  'Marketing Agency',
  'Sales Agency',
  'Consultant',
  'Business Services',
  'Association',
  'IRI Partner Account',
  'Private Equity/Financial Institution',
  'Strategic Partner',
  'Ventures',
  'Biotechnology/Research & Development',
  'Professional Services',
  'University',
  'Partner',
  'Financial Partner',
  'Manufacturer Service Provider',
  'Consumer Applications / Tech Platforms',
  'Marketing / Ecosystem Partner',
  'Retailer Service Provider / Data Acquisition',
  'Other',
  'Rolodex',
  'Unknown',
  'Internal',
];

// HubSpot template ID for the IX-ONE company sign-up activation email.
export const COMPANY_SIGNUP_EMAIL_TEMPLATE_ID = 220400254874;

// Hubspot template ID for new user without company admin
export const REQUEST_TO_JOIN_EMAIL_TEMPLATE_ID = 221617031243;

export const SPINS_SUPPORT_EMAIL = 'support@spins.com';

export const EMAIL_LOOKUP_ERROR_MESSAGE =
  "We couldn't look up your email right now. Please try again.";

export const VERIFICATION_EMAIL_ERROR_MESSAGE =
  "We couldn't send your verification email right now. Please try again.";

export const COMPANY_SIGN_UP_ERROR_MESSAGE =
  "We couldn't submit your company information right now. Please try again.";

export const NEW_USER_REQUEST_ERROR_MESSAGE =
  "We couldn't submit your request to join right now. Please try again.";
